import { Header } from "../../elements/header/Header"


export default function Settings() {
    return <>
        <Header />
    </>
}